import classNames from 'classnames';
import React, { memo } from 'react';

import NextImage from '@com/_core/NextImage';
import Badge from '@com/shared/badge';
import CatalogLink from '@com/seo/CatalogLink';
import Counter from '../../shared/counter';
import { Product } from '../plpCard.types';
import BadgeLabel from '@com/shared/cards/badgeLabel';

interface NonOtcPlpVerticalCardProps {
  onClickHandler: (e: any) => void;
  product: Product;
  hasAddToCart?: boolean;
  className?: string;
  href?: string;
  imagePriority?: boolean;
}

const NonOtcPlpVerticalCard = memo(
  ({
    onClickHandler,
    product,
    hasAddToCart,
    className,
    href,
    imagePriority = false,
  }: NonOtcPlpVerticalCardProps) => {
    return (
      <div
        className={classNames(
          className,
          'relative m-auto h-60 min-h-[244px] w-full bg-white rounded-xl px-2 py-2 shadow-practicalTop justify-center cursor-pointer',
        )}
      >
        {href ? (
          <CatalogLink
            href={href}
            className="absolute inset-0 z-[1]"
            ariaLabel={product?.productName}
          >
            <span className="sr-only">{product?.productName}</span>
          </CatalogLink>
        ) : (
          <div onClick={onClickHandler} className="absolute inset-0 z-[1]" />
        )}
        <div className="relative h-28 m-auto bg-white rounded-lg flex justify-center items-center max-w-[112px]">
          <NextImage
            src={product?.imageLink}
            alt={product?.productName || 'تصویر محصول'}
            width={112}
            height={112}
            priority={imagePriority}
          />
          {product?.isRare && (
            <BadgeLabel
              text="داروی‌کمیاب"
              iconName="Spark"
              className="top-0 -right-10 pointer-events-none"
            />
          )}
          {hasAddToCart ? <Counter product={product} /> : null}
        </div>
        <div className="pointer-events-none flex flex-col h-[calc(100%-112px)] pb-4 pt-2">
          <div className="mt-2 text-xs md:min-h-[36px]">
            <p className="line-clamp-2">{product?.productName}</p>
          </div>
          <div className="mt-auto">
            <div className="mt-2 text-xs flex gap-1 items-center">
              {product?.shapeName && (
                <>
                  <Badge color="blue" className="h-[22px]">
                    {product?.shapeName}
                  </Badge>
                  <span className="me-1">/</span>
                </>
              )}
              {product.brandName && (
                <div className="overflow-x-auto flex">
                  <Badge color="green" className="h-[22px]">
                    {product?.brandName}
                  </Badge>
                </div>
              )}
            </div>
            <div className="h-[22px] mt-2 text-xs w-full flex overflow-x-auto text-nowrap">
              {product?.slangs?.length > 0 && (
                <>
                  {product?.slangs?.map((item, index) => (
                    <Badge key={index} color="gray" className="h-[22px]">
                      {item}
                    </Badge>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default NonOtcPlpVerticalCard;
